import { render } from "./header-bar.vue?vue&type=template&id=18b554cb&scoped=true"
import script from "./header-bar.vue?vue&type=script&lang=js"
export * from "./header-bar.vue?vue&type=script&lang=js"

import "./header-bar.vue?vue&type=style&index=0&id=18b554cb&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2743156286/src/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b554cb"]])

export default __exports__